import { render } from "./Switcher.vue?vue&type=template&id=5218b481"
import script from "./Switcher.vue?vue&type=script&lang=js"
export * from "./Switcher.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__